import { render, staticRenderFns } from "./AllCompanyProducts.vue?vue&type=template&id=1b5df189&"
import script from "./AllCompanyProducts.vue?vue&type=script&lang=js&"
export * from "./AllCompanyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports